import { render, staticRenderFns } from "./NaPai.vue?vue&type=template&id=4940f063&scoped=true&"
import script from "./NaPai.vue?vue&type=script&lang=js&"
export * from "./NaPai.vue?vue&type=script&lang=js&"
import style0 from "./NaPai.vue?vue&type=style&index=0&id=4940f063&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940f063",
  null
  
)

export default component.exports